import React from 'react'
import { Card, Drawer, Form, Icon, notification, Button, Tooltip } from 'antd'
import _ from 'lodash'
import { connect } from 'react-redux'
import ReceiptPDF from '../pdf/receiptPDF'

import Request from '../../request'

class ReceiptView extends React.Component {
    state = {
        visible: true,
        generatedReceipt: {},
        businessId: ''
    }

    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    loadReceiptDetail = async () => {
        const { recordId } = this.props;
        const res = await Request.accountPaymentDetailsByID({ id: recordId });
        if (!res.error) {
            this.setState({ generatedReceipt: res.doc, businessId: res.doc.businessId });
        }
    }

    componentWillMount() {
        this.loadReceiptDetail();
    }

    // downloadReceipt = () => {
    //     var printContents = document.getElementById('table_with_data').innerHTML;
    //     var originalContents = document.body.innerHTML;
    //     document.body.innerHTML = printContents;
    //     window.print();
    //     document.body.innerHTML = originalContents;
    // }

    downloadReceipt = () => {
        const content = document.getElementById('table_with_data');
        const win = window.open('', '', 'height=800,width=1000');

        // Get all existing stylesheets and style tags from the current page
        const styles = Array.from(document.head.querySelectorAll('style, link[rel="stylesheet"]'))
            .map(node => node.outerHTML)
            .join('\n');

        win.document.write(`
        <html>
            <head>
                <title>Receipt</title>
                ${styles}
            </head>
            <body>
                <div>${content.innerHTML}</div>
            </body>
        </html>
    `);

        win.document.close();
        win.focus();

        setTimeout(() => {
            win.print();
            win.close();
            this.onClose();
        }, 500);
    }



    render() {
        const { generatedReceipt, businessId } = this.state;
        return (
            <Drawer
                title={
                    <div>
                        {'Receipt'} {' '}
                        <a onClick={this.onClose} style={{ float: 'right', color: 'black' }}>
                            <Icon type={'close'} />
                        </a>
                    </div>
                }
                placement="right"
                closable={false}
                onClose={this.onClose}
                width={1100}
                visible={this.state.visible}>
                <div>
                    <Tooltip title="Download Receipt ">
                        <Button
                            loading={false}
                            shape="circle"
                            icon="download"
                            onClick={() => { this.downloadReceipt() }}
                        />
                    </Tooltip>
                    <Card id='table_with_data'>
                        <ReceiptPDF generatedReceipt={generatedReceipt} businessId={businessId} />
                    </Card>
                </div>
            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReceiptView)